import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppButton } from "./Generic/AppButton";
import ScaffoldTitle from "./Scaffold/components/ScaffoldTitle";
import Scaffold from "./Scaffold/Scaffold";

interface Props {
  title: string;
  message: string;
  onClickRetry?: () => void;
  onClickGoBack: () => void;
}

const ErrorScaffold = (props: Props) => {
  return (
    <Scaffold title={<ScaffoldTitle label={props.title} />} onClickGoBack={props.onClickGoBack}>
      <ErrorScaffold.Body>
        <ErrorMessage>{props.message}</ErrorMessage>
        {props.onClickRetry !== undefined ? (
          <AppButton size="small" color="danger" variant="soft" onClick={props.onClickRetry}>
            {translate(STRINGS.RETRY)}
          </AppButton>
        ) : (
          <AppButton size="small" color="danger" variant="soft" onClick={props.onClickGoBack}>
            {translate(STRINGS.GO_BACK)}
          </AppButton>
        )}
      </ErrorScaffold.Body>
    </Scaffold>
  );
};

const ErrorMessage = styled.p``;

ErrorScaffold.Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export default ErrorScaffold;
